import { render, staticRenderFns } from "./ReturnView.vue?vue&type=template&id=32e32fc6&scoped=true"
import script from "./ReturnView.vue?vue&type=script&lang=js"
export * from "./ReturnView.vue?vue&type=script&lang=js"
import style0 from "./ReturnView.vue?vue&type=style&index=0&id=32e32fc6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32e32fc6",
  null
  
)

export default component.exports